export enum QuestionType {
    Checkbox,
    Dropdown,
    AcknowledgeEndTime,
    DOB,
    ReasonsForVisit,
    DietaryRestrictions,
    Text,
    DietaryRestrictionsText,
}

export const QuestionTypeNaturalOrder = [
    QuestionType.AcknowledgeEndTime,
    QuestionType.Checkbox,
    QuestionType.Dropdown,
    QuestionType.ReasonsForVisit,
    QuestionType.DOB,
    QuestionType.DietaryRestrictions,
    QuestionType.DietaryRestrictionsText,
    QuestionType.Text,
]

export class Question {
    constructor(
        public id: string,
        public text: string,
        public required: boolean,
        public type: QuestionType,
        public options: string[],
        public reasonIds: string[],
        public active: boolean = true
    ) { }

    get isTickable(): boolean {
        return this.type === QuestionType.Checkbox || this.type === QuestionType.AcknowledgeEndTime
    }

    get dietaryRestrictionOptions(): string[] {
        return [
            'Vegetarian',
            'Vegan',
            'Gluten Free',
            'Dairy Free',
            'Nut Allergy',
            'Shellfish Allergy',
            'Egg Allergy',
            'Soy Allergy',
            'Pescatarian',
            'Halal',
            'Kosher',
            'Low Sodium',
            'Diabetic Friendly',
            'Keto',
            'Paleo',
            'Melon Allergy',
        ]
    }
}
